
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { FaqItem, JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class PelletlagerReinigung extends Vue {
  faqItems: FaqItem[] = [
    {
      question: "Wie oft sollte man ein Pelletlager reinigen?",
      answer:
        "Experten empfehlen, das Pelletlager alle 2–3 Jahre oder nach 2–3 Befüllungen zu reinigen. Bei hochwertigen Pellets reicht oft eine Reinigung vor jeder vierten Lieferung.",
    },
    {
      question: "Wie lange dauert eine Pelletlager Reinigung?",
      answer:
        "Eine Lagerreinigung nimmt zwischen 1 und 2 Stunden in Anspruch. Die genaue Dauer hängt von Lagergröße, Verschmutzungsgrad und Restmengen ab.",
    },
    {
      question: "Kann man restliche Pellets absaugen lassen?",
      answer:
        "Ja, bei einer professionellen Pelletlager Reinigung können Restpellets mit entsprechender Absaugtechnik entfernt werden. Dieser Service gehört zum Standardumfang.",
    },
    {
      question: "Wer kann eine Pelletlager Reinigung durchführen?",
      answer:
        "Die Lagerreinigung können spezialisierte Fachbetriebe durchführen, die über das nötige Equipment verfügen. Häufig übernehmen regionale Pellethändler den Service und kombinieren ihn mit der Pelletlieferung.",
    },
    {
      question: "Was kostet das Pelletlager reinigen?",
      answer:
        "Die Pelletlager Reinigung kostet in der Regel ab 300 Euro. Die Kosten variieren je nach Größe und Verschmutzungsgrad des Lagers sowie der Menge an Rückständen.",
    },
    {
      question: "Welche Ausrüstung braucht man zum Pelletlager reinigen?",
      answer:
        "Für die Pelletlager Reinigung benötigen Sie: FFP2-Staubmaske, Schutzbrille und Handschuhe, einen Industriesauger mit Feinstaubfilter sowie Pinsel für schwer zugängliche Stellen.",
    },
    {
      question: "Kann man ein Pelletlager auch im Winter reinigen?",
      answer:
        "Grundsätzlich ja, aber optimal ist die Pelletlager Reinigung im Sommer, wenn das Lager leer ist. So vermeiden Sie Betriebsunterbrechungen und können die Reinigung mit der Neubefüllung verbinden.",
    },
  ];

  head() {
    return {
      ...generateMetaTags(this.$route.path, "pelletlager-reinigung"),
      link: [{ rel: "canonical", href: this.$route.path }],
      script: [
        {
          type: "application/ld+json",
          json: {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: this.faqItems.map((faq) => ({
              "@type": "Question",
              name: faq.question,
              acceptedAnswer: {
                "@type": "Answer",
                text: faq.answer,
              },
            })),
          },
        },
      ],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Wann sollten Sie Ihr Pelletlager reinigen?",
        title: "Springen Sie zum Bereich: Wann reinigen?",
        href: { hash: "#anker-wann" },
      },
      {
        name: "Selbst machen oder Profi beauftragen?",
        title: "Springen Sie zum Bereich: Selbst machen oder Profi?",
        href: { hash: "#anker-selbst-oder-profi" },
      },
      {
        name: "Ablauf & Kosten",
        title: "Springen Sie zum Bereich: Professioneller Ablauf & Kosten",
        href: { hash: "#anker-profi-ablauf-kosten" },
      },
      {
        name: "Professionelle Pelletlager Reinigung: Ablauf und Kosten",
        title: "Springen Sie zum Bereich: Schritt-für-Schritt selbst reinigen",
        href: { hash: "#anker-selber-reinigen" },
      },
      {
        name: "Warum ist Pelletlager Reinigung so wichtig?",
        title: "Springen Sie zum Bereich: Warum Reinigung wichtig ist",
        href: { hash: "#anker-warum-wichtig" },
      },
      {
        name: "FAQ",
        title: "Springen Sie zum Bereich: Häufige Fragen",
        href: { hash: "#anker-faq" },
      },
      {
        name: "Regelmäßige Pelletlager Reinigung zahlt sich aus",
        title: "Springen Sie zum Bereich: Fazit",
        href: { hash: "#anker-fazit" },
      },
      {
        name: "Preisvergleich",
        title: "Springen Sie zum Bereich: Preisvergleich",
        href: { hash: "#anker-preisvergleich" },
      },
    ];
  }
}
